import React, { forwardRef } from 'react';
import styles from './FilterPills.module.css';

export interface IFilterPillsProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  options: Array<{ label: string; value: string }>;
  selected: string;
  onChange: (value: string) => void;
}

const FilterPills = forwardRef<HTMLDivElement, IFilterPillsProps>(
  ({ options, selected, onChange, className, ...rest }, ref) => {
    const selectedIndex = options.findIndex((opt) => opt.value === selected);
    const pillWidth = 100 / options.length;

    return (
      <div ref={ref} className={`${styles.filterPills} ${className || ''}`} {...rest}>
        {options.map((option) => (
          <button
            key={option.value}
            className={styles.pill + (selected === option.value ? ' ' + styles.pillActive : '')}
            onClick={() => onChange(option.value)}
            style={{ zIndex: selected === option.value ? 'var(--z-above)' : 'var(--z-raised)' }}
          >
            {option.label}
          </button>
        ))}
        <div
          className={styles.pillSliderBg}
          style={{
            left: `${selectedIndex * pillWidth}%`,
            width: `${pillWidth}%`,
          }}
        />
      </div>
    );
  },
);

FilterPills.displayName = 'FilterPills';

export default FilterPills;
